import { Card, CardContent } from "@/components/ui/card";
import { ChevronDown, ChevronUp } from "lucide-react";
import SkillChecklist from "@/components/SkillChecklist";

export default function SkillMemberCard({ member: m, progress, isOpen, skillsData, onExpand, onToggleSkill }) {
  return (
    <Card className="card-shadow-soft" data-testid={`skill-card-${m.id}`}>
      <CardContent className="p-4">
        <button className="w-full text-left" onClick={() => onExpand(m.id)} data-testid={`skill-expand-${m.id}`}>
          <div className="flex items-center justify-between gap-2">
            <div className="min-w-0">
              <div className="font-semibold truncate">{m.full_name}</div>
              <div className="text-xs text-muted-foreground">{progress.completed} of {progress.total} skills completed</div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-24 bg-secondary rounded-full h-2 overflow-hidden">
                <div className="h-full bg-primary transition-all" style={{ width: `${progress.pct}%` }} />
              </div>
              <span className="text-sm font-bold w-12 text-right" style={{ fontFamily: "JetBrains Mono" }}>{progress.pct}%</span>
              {isOpen ? <ChevronUp className="w-4 h-4 text-muted-foreground" /> : <ChevronDown className="w-4 h-4 text-muted-foreground" />}
            </div>
          </div>
        </button>
        {isOpen && skillsData && <SkillChecklist data={skillsData} memberId={m.id} onToggle={onToggleSkill} />}
      </CardContent>
    </Card>
  );
}
